export default __webpack_public_path__ + "static/media/foto_01.29439880.jpg";